import { TTotal } from "@/module/common";
import { TGetDataId, TdataListType, TdataDetailsType, TGetParentId, TdataMenuType, TDirecId } from "@/module/databank";
import request from "@/utils/requset";

//获取左边菜单
export const getDataMenu = (data: TGetParentId) => {
    return request<TGetParentId, TdataMenuType[]>({
        url: '/api/user/resources/getuserauthstrdiclist',
        method: 'GET',
        data
    })
}

//资料库列表
export const getDataList = (data: TDirecId) => {
    return request < TDirecId, TTotal< TdataListType[] >>({
        url: '/api/user/resourcescontent/resourcescontentlist',
        method: 'POST',
        data
    })
}

//获取资料库详情
export const getDataDetails = (data: TGetDataId) => {
    return request<TGetDataId, TdataListType>({
        url: '/api/user/resourcescontent/resourcescontentinfo',
        method: 'GET',
        data
    })
}